import { defineMessages } from 'react-intl-next';

export const messages: {
    dismiss: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	dismiss: {
		id: 'oauth-message-dismiss',
		defaultMessage: 'Dismiss',
		description: 'Message for button to dismiss the oauth message',
	},
});
